import { render } from "./WCCartDrawerOrderTypeGroup.vue?vue&type=template&id=3cf2fd60"
import script from "./WCCartDrawerOrderTypeGroup.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerOrderTypeGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__